"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.type.text': 'Tekst',
    'question.type.textarea': 'Obszar tekstu',
    'question.type.select': 'Wybór',
    'question.type.radio': 'Radio',
    'question.type.checkbox': 'Checkbox',
    'question.type.number': 'Liczba',
    'question.type.email': 'Email',
    'question.type.url': 'URL',
    'question.type.date': 'Data',
};
